import LogoIcon from 'ui-component/Logo';

// Fixed (docs/PENDING-FINDINGS.md finding #63): this used to wrap LogoIcon in its own
// <Link to="/">, but its only caller (Header.tsx) already wraps <Logo/> in a RouterLink to
// the same destination — nesting an <a> inside another <a>, which React warns about as
// invalid HTML/a hydration hazard. Header already provides the link; this component just
// renders the icon.
export default function Logo() {
  return <LogoIcon />;
}
